import { getUrl, sessionExpired } from "../setEnvironment";
class MapAPI {
  constructor() {
    this.URL = getUrl();
    this.getMap = this.getMap.bind(this);
    this.getQueuePositions = this.getQueuePositions.bind(this);
    this.getRotatePositions = this.getRotatePositions.bind(this);
    this.getMapPositions = this.getMapPositions.bind(this);
    this.getPositionTypes = this.getPositionTypes.bind(this);
  }

  // P01021-142 (mapa): search/type/status filtran por servidor sobre todo el dataset, no solo
  // la página cargada — opcionales, se omiten de la query si no se pasan.
  // P01021-137: el usuario se resuelve en el backend a partir del token de sesión.
  async getMap(token, size, page, search, type, status) {
    try {
      let url = `${this.URL}/map/getMap?size=${size}&page=${page}`;
      if (search) url += `&search=${encodeURIComponent(search)}`;
      if (type) url += `&type=${encodeURIComponent(type)}`;
      if (status !== undefined && status !== "") url += `&status=${encodeURIComponent(status)}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  async getQueuePositions(token) {
    try {
      const response = await fetch(`${this.URL}/map/queuePositions`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  async getRotatePositions(token) {
    try {
      const response = await fetch(`${this.URL}/map/rotatePositions`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  async getMapPositions(token) {
    try {
      const response = await fetch(`${this.URL}/map/mapPositions`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  // P01021-142 (mapa): tipos de posición que existen de verdad en la BD, para no listar en el
  // filtro los ~30 tipos posibles de RCS cuando la instalación solo usa unos pocos.
  async getPositionTypes(token) {
    try {
      const response = await fetch(`${this.URL}/map/positionTypes`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

}

let _mapAPI = null;

const initMapAPI = () => {
  if (!_mapAPI) {
    _mapAPI = new MapAPI();
  }
  return _mapAPI;
};

const getMapAPI = () => {
  return initMapAPI();
};

export { initMapAPI, getMapAPI };
